import BrandMark from "./BrandMark";

const sectors=["Talleres","Clínicas","Peluquerías","Inmobiliarias","Despachos"];

function Wave(){
 return <span className="premium-wave" aria-hidden="true">
  {Array.from({length:19},(_,i)=><i key={i}/>)}
 </span>;
}

export default function MarketingApp(){
 return <div className="marketing-site premium-v2">
  <header className="premium-nav-wrap">
   <div className="premium-nav">
    <a href="#inicio" className="premium-logo"><BrandMark/></a>
    <nav aria-label="Navegación principal">
     <a href="#producto">Producto</a><a href="#experiencia">Experiencia</a><a href="#confianza">Confianza</a>
    </nav>
    <a className="premium-nav-cta" href="#demo">Ver MIL</a>
   </div>
  </header>

  <main>
   <section className="premium-hero" id="inicio">
    <div className="premium-hero-copy">
     <span className="premium-eyebrow">MIL IAgentes · recepción inteligente</span>
     <h1>Tu negocio,<br/><span>siempre presente.</span></h1>
     <p>Una capa de atención inteligente que escucha, entiende, actúa dentro de tus reglas y deja todo bajo tu control.</p>
     <div className="premium-actions">
      <a className="premium-button dark" href="#experiencia">Ver cómo trabaja</a>
      <a className="premium-link" href="/">Abrir panel <span>↗</span></a>
     </div>
     <small>Preview interno · FASE 5E · entorno sintético</small>
    </div>
    <div className="premium-hero-visual" aria-hidden="true">
     <div className="premium-halo halo-a"/><div className="premium-halo halo-b"/>
     <div className="premium-device">
      <div className="premium-device-top"><span/><b>MIL</b><i/></div>
      <div className="premium-call-status"><span>LLAMADA EN CURSO</span><i>00:42</i></div>
      <div className="premium-caller"><small>Recepción</small><strong>¿En qué puedo ayudarte?</strong></div>
      <Wave/>
      <div className="premium-resolved">
       <span className="premium-check">✓</span>
       <div><b>Cita comprobada</b><small>Acción validada antes de confirmar</small></div>
      </div>
     </div>
     <div className="premium-float-card float-left"><small>CONOCIMIENTO</small><b>Solo información aprobada</b></div>
     <div className="premium-float-card float-right"><small>CONTROL</small><b>Todo queda visible</b></div>
    </div>
   </section>

   <section className="premium-statement">
    <p>No se trata de sonar como una persona.<br/><strong>Se trata de resolver como un buen equipo.</strong></p>
   </section>

   <section className="premium-product" id="producto">
    <div className="premium-section-head">
     <span>Producto</span>
     <h2>Una llamada entra.<br/>MIL hace el resto.</h2>
    </div>
    <div className="premium-story-grid">
     <article className="story-card story-dark"><span>01</span><div><h3>Atiende</h3><p>Recibe la consulta y trabaja con el contexto autorizado del negocio.</p></div><Wave/></article>
     <article className="story-card"><span>02</span><div><h3>Entiende</h3><p>Identifica la intención sin inventar información ni saltarse tus reglas.</p></div><div className="intent-pill">Cita · disponibilidad</div></article>
     <article className="story-card"><span>03</span><div><h3>Actúa</h3><p>Comprueba herramientas y ejecuta solo las acciones que el servidor permite.</p></div><div className="action-orbit"><i/><i/><i/></div></article>
     <article className="story-card story-accent"><span>04</span><div><h3>Te informa</h3><p>La interacción queda registrada para que tu equipo sepa qué pasó y qué sigue.</p></div><div className="result-lines"><i/><i/><i/></div></article>
    </div>
   </section>

   <section className="premium-experience" id="experiencia">
    <div className="experience-copy">
     <span className="premium-eyebrow">Diseñado para desaparecer del camino</span>
     <h2>Menos interrupciones.<br/>Más negocio atendido.</h2>
     <p>MIL no pretende reemplazar tu negocio. Se ocupa del ruido operativo para que tú puedas dedicarte a lo que requiere criterio, experiencia y trato personal.</p>
    </div>
    <div className="experience-console" aria-hidden="true">
     <div className="console-glass">
      <header><span className="console-brand"><BrandMark compact/></span><small>Ahora</small></header>
      <div className="console-row"><i className="green-dot"/><div><b>Consulta atendida</b><small>Horario y servicio</small></div><span>Resuelta</span></div>
      <div className="console-row"><i className="blue-dot"/><div><b>Cita solicitada</b><small>Disponibilidad comprobada</small></div><span>Confirmada</span></div>
      <div className="console-row"><i className="gold-dot"/><div><b>Mensaje recibido</b><small>Requiere revisión humana</small></div><span>Pendiente</span></div>
     </div>
    </div>
   </section>

   <section className="premium-sectors">
    <span className="premium-eyebrow">Donde cada llamada importa</span>
    <div className="premium-sector-strip">{sectors.map((s,i)=><article key={s}><span>0{i+1}</span><b>{s}</b></article>)}</div>
   </section>

   <section className="premium-trust" id="confianza">
    <div className="trust-copy">
     <span className="premium-eyebrow">Control por diseño</span>
     <h2>La inteligencia importa.<br/>Los límites también.</h2>
     <p>Información aprobada, capacidades resueltas por servidor, datos aislados por negocio y acciones sensibles sujetas a reglas explícitas.</p>
    </div>
    <div className="trust-stack">
     <article><span>01</span><div><b>No inventa disponibilidad</b><small>Comprueba antes de confirmar.</small></div></article>
     <article><span>02</span><div><b>No decide permisos</b><small>Las capacidades viven fuera del modelo.</small></div></article>
     <article><span>03</span><div><b>No oculta lo que hace</b><small>El negocio conserva visibilidad operativa.</small></div></article>
    </div>
   </section>

   <section className="premium-cta" id="demo">
    <div className="premium-cta-glow"/>
    <BrandMark compact/>
    <h2>Una nueva forma de estar<br/>al otro lado del teléfono.</h2>
    <p>MIL IAgentes está en staging sintético. La publicación comercial permanece bloqueada hasta superar los gates de FASE 5E.</p>
    <a className="premium-button light" href="/">Entrar al panel</a>
   </section>
  </main>

  <footer className="premium-footer"><BrandMark/><span>Preview de staging · MIL IAgentes 2026</span></footer>
 </div>;
}
